// Shared Framer Motion variants used across pages for a cohesive feel.

const EASE = [0.22, 1, 0.36, 1];

// Stagger container for grids of cards (reveal on scroll).
export const gridContainer = {
    hidden: {},
    show: { transition: { staggerChildren: 0.1 } },
};

// Individual card / item: fade + rise.
export const gridItem = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
};

// Hero content: stagger its children in on mount.
export const heroContainer = {
    hidden: {},
    show: { transition: { staggerChildren: 0.15, delayChildren: 0.15 } },
};

// Springy lift used for whileHover on cards.
export const cardHover = {
    y: -8,
    transition: { type: 'spring', stiffness: 300, damping: 20 },
};

// Slide-in from a side (for two-column layouts).
export const fromLeft = {
    hidden: { opacity: 0, x: -40 },
    show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: EASE } },
};
export const fromRight = {
    hidden: { opacity: 0, x: 40 },
    show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: EASE } },
};

// Standard whileInView viewport config (animate once, when 20% visible).
export const viewportOnce = { once: true, amount: 0.2 };
